<template>
  <AdminConfirmModal
    v-model="getDeclineRequestModal"
    :message="$t('Tariffs.sure_want_decline')"
    :confirm-text="$t('Default.accept')"
    @confirm="declineRequest"
  />
</template>
<script>
import { ref } from "@vue/composition-api";
import { GlobalMutationTypes } from "@/store/modules/global/types";
import { DispatchTypes } from "@/store/modules/admin/request/types";
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: ["currentRequestInfo"],
  setup(props, { emit }) {
    const store = useStore();

    const { userInfo } = globalVariables();

    const getDeclineRequestModal = shortComputed(
      {
        storeType: "global",
        key: "getDeclineRequestModal",
      },
      GlobalMutationTypes.setDeclineRequestModal
    );

    const payload = ref({
      status: 3,
    });

    const declineRequest = () => {
      store
        .dispatch(DispatchTypes.changeStatusRequest, {
          id: props.currentRequestInfo.id,
          payload: payload.value,
        })
        .then(() => {
          store.commit(GlobalMutationTypes.setDeclineRequestModal, false);
          emit("success");
          store.dispatch(DispatchTypes.getRequests, "?status=" + 1);
        });
    };

    return {
      store,
      getDeclineRequestModal,
      declineRequest,
      userInfo,
      payload,
    };
  },
};
</script>
